// import { Modifier } from './modifier';
import { OrderItem } from './order_item';

export class Order {
    constructor(order) {
        this.id = order.id;
        this.customer_id = order.customer_id;
        this.customer_name = order.customer_name;
        this.customer_phone = order.customer_phone;
        this.customer_email = order.customer_email;
        this.customer_address = order.customer_address;
        this.payment_method = order.payment_method;
        this.currency = order.currency;
        this.start_time = order.start_time;
        this.expected_end_time = order.expected_end_time;
        this.end_time = order.end_time;
        this.picked_up_time = order.picked_up_time;
        this.promotion_code = order.promotion_code;
        this.total_before_discount = order.total_before_discount;
        this.total_after_discount = order.total_after_discount;
        this.employee_id = order.employee_id;
        this.employee_name = order.employee_name;
        this.type = order.type;
        this.note = order.note;
        this.owner_note = order.owner_note;
        this.order_status = order.order_status;
        this.status = order.status;
        this.created_at = order.created_at;
        this.updated_at = order.updated_at;
        this.cancel_reason = order.cancel_reason;
        this.delivered_time = order.delivered_time;
        this.completed_time = order.completed_time;
        this.order_code = order.order_code;
        this.payment = order.payment;
        // this.order_details = order.order_details;
        this.invoice = order.invoice;
        this.order_items = order.order_items ? this.getOrderItems(order.order_items) : [];
    }
    
    getOrderItems(order_items) {
        let arr = [];
        for(let i = 0; i < order_items.length; i++) {
            arr.push(new OrderItem(order_items[i]));
        }
        return arr;
    }
}

// class Variant {
//     constructor(item_variant) {
//         this.id = item_variant.id;
//         this.image = item_variant.image;
//         this.name = item_variant.name;
//         this.description = item_variant.description;
//         this.price = item_variant.price;
//         this.status = item_variant.status;
//     }
// }
// class OrderItem {
//     constructor(order_item) {
//         this.id = order_item.id;
//         this.order_id = order_item.order_id;
//         this.item_id = order_item.item_id;
//         this.quantity = order_item.quantity;
//         this.item_name = order_item.item_name;
//         this.price = order_item.price;
//         this.note = order_item.note;
//         this.owner_note = order_item.owner_note;
//         this.status = order_item.status;
//         this.created_at = order_item.created_at;
//         this.updated_at = order_item.updated_at;
//         this.cancel_reason = order_item.cancel_reason;
//         this.item_image = order_item.item_image;
//         this.item_variant = order_item.item_variant ? new Variant(order_item.item_variant) : {};
//         this.item_modifier = order_item.item_modifier ? this.getItemModifier(order_item.item_modifier) : [];
//     }

//     getItemModifier(item_modifier) {
//         let arr = [];
//         for(let i = 0; i < item_modifier.length; i++) {
//             arr.push(new Modifier(item_modifier[i]));
//         }
//         return arr;
//     }
// }